import { t } from "i18next";

import { HeaderProps } from "./Header.types";

import styles from "./Header.module.scss";

const Header = ({ title, counter, action = null }: HeaderProps) => {
  return (
    <header className={styles.header}>
      <h1 className={styles.header__title}>
        {typeof title === "string" ? t(title) : title}
        {!!counter && (
          <span className={styles.header__counter}>
            {" "}
            ({counter.toLocaleString("en-US")})
          </span>
        )}
      </h1>
      {action}
    </header>
  );
};

export default Header;
